import { Component, OnInit } from '@angular/core';
import { CustomDashboardsService } from 'app/modules/my-limegear/services/my-limegear.service';
import { PerformanceService } from 'app/modules/performance/services/performance.service';
import { ITableTdItems } from 'app/modules/shared/interfaces/card-data';
import { NoDataActionType } from 'app/modules/shared/interfaces/no-data';
import { ICardInfo } from '../../interfaces/stanalone-components.data';
import { SmallCardService } from '../../services/small-card.service';

@Component({
    selector: 'app-performance-top-producer-smc',
    templateUrl: './performance-top-producer-smc.component.html',
    styleUrls: ['./performance-top-producer-smc.component.scss'],
})
export class PerformanceTopProducerSmcComponent implements OnInit {
    cardInfo: ICardInfo;

    constructor(
        private _customDashboardsService: CustomDashboardsService,
        private _smallcardService: SmallCardService,
        private performanceService: PerformanceService
    ) {}

    ngOnInit(): void {
        this.cardInfo = {
            cardId: 'topProducersByscore',
            title: 'Top 5 producers by YTD weighted score',
            isHeadcount: false,
            type: 'Score',
            range: 'top',
            rangeType: 'Number',
            rangeLimit: 5,
            cardDataRowinfo: this.performanceService.getRankingAndScoreTableInfo().scoreTableInfo,
        };
        let action = NoDataActionType.pageStart;
        this._customDashboardsService.filterChangesSubject$.subscribe((changes) => {
            this.cardInfo.card = this._smallcardService.initializeSmallCard(this.cardInfo, action);
            this.cardInfo.card.routerLink = '/reporting/performance';
            this.cardInfo.card.unit = this.cardInfo.units;
            this._smallcardService.preparePerformancePage(
                changes.displayOptions,
                changes.hierarchyfilters,
                this.cardInfo,
                changes.action
            );
        });
    }
}
